// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const { getFormattedLanguage } = require('../utilities/RALanguageHelper');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const {
    TIME_HORIZON_CHECK_ERROR,
    TIME_HORIZON_CHECK_NOT_PERFORMED,
    TIME_HORIZON_CHECK_VALID,
    TIME_HORIZON_CHECK_WARNING,
} = require('../raConstants/index');

const setTimeHorizonCheck = newHorizonTime => ({
    type: actionTypes.RA_TIME_HORIZON_CHECK_SET_TIME,
    newHorizonTime,
});

const timeHorizonCheckInProgress = () => ({
    type: actionTypes.RA_TIME_HORIZON_CHECK_REQUEST,
});

const timeHorizonCheckSuccess = response => ({
    type: actionTypes.RA_TIME_HORIZON_CHECK_SUCCESS,
    payload: {
        HTPI: response.timeHorizon || false,
        ipModification: response.modificationOfInvestmentProfile,
        maxTypeOfProduct: response.maxTypeOfProduct || 0,
    },
});

const timeHorizonCheckFailure = error => ({
    type: actionTypes.RA_TIME_HORIZON_CHECK_FAILURE,
    payload: error,
});

const resetMaxTypeOfProduct = () => ({
    type: actionTypes.RA_TIME_HORIZON_CHECK_RESET_TIME_HORIZON_CHECK,
});

const timeHorizonCheck = (
    validCallback = () => {},
    warningCallback = () => {},
) => (dispatch, getState) => {
    const status = getState().raTimeHorizonCheck.get('status');

    if (
        status == TIME_HORIZON_CHECK_WARNING ||
        status == TIME_HORIZON_CHECK_VALID
    ) {
        validCallback();
    } else if (
        status == TIME_HORIZON_CHECK_ERROR ||
        status == TIME_HORIZON_CHECK_NOT_PERFORMED
    ) {
        const language = getFormattedLanguage();
        const newHorizonTime = getState().raTimeHorizonCheck.get(
            'newHorizonTime',
        );
        const requestData = {
            header: {
                'Accept-Language': language,
            },
        };

        dispatch(timeHorizonCheckInProgress());

        return APIGet(
            dispatch,
            apiURLBuilder.getURL('raTimeHorizonCheck', {
                date: newHorizonTime,
            }),
            requestData,
        )
            .then(response => {
                dispatch(timeHorizonCheckSuccess(response));
                const status = getState().raTimeHorizonCheck.get('status');

                if (status == TIME_HORIZON_CHECK_VALID) {
                    validCallback();
                } else if (status == TIME_HORIZON_CHECK_WARNING) {
                    warningCallback();
                }
            })
            .catch(error => {
                if (error) {
                    dispatch(timeHorizonCheckFailure(error.description));
                } else {
                    throw error;
                }
            });
    }
};

module.exports = {
    setTimeHorizonCheck,
    resetMaxTypeOfProduct,
    timeHorizonCheck,
};
